import {
  Field,
  Fieldset,
  FormCategory,
  FormClassified
} from '~/models/classified/form'
import { toCamelCase } from '~/utils/object'

export function formatFieldset(f: any): Fieldset {
  return {
    humanName: f.human_name,
    name: f.name,
    fields: f.fields.map(formatField),
    order: f.order,
    isCollapsed: f.is_collapsed,
    extras: f.extras
  }
}

export function formatFormClassified(c: any): FormClassified {
  return {
    info: toCamelCase(c.info),
    fieldValues: c.field_values,
    incompleteFieldValues: c.incomplete_field_values,
    id: c.id,
    owner: c.owner,
    suggestedCategory: c.suggestedCategory
      ? toCamelCase(c.suggestedCategory)
      : null
  }
}

export function formatField(f: any): Field {
  return {
    name: f.name,
    required: f.required,
    specs: f.specs,
    id: f.id,
    disabled: f.disabled,
    humanName: f.human_name,
    type: f.type,
    order: f.order,
    suggestions: f.suggestions
  }
}

export function formatFormCategory(c: any): FormCategory {
  return {
    categoryIds: c.category_ids,
    humanName: c.human_name,
    humanNamePlural: c.human_name_plural,
    id: c.id,
    name: c.name,
    isBase: c.isBase
  }
}
